if ($('#frmRestaurantDetails').length) {
    var initRestaurantDetails = function () {
        var $form = $('#frmRestaurantDetails');

        $(function () {
            var action = $form.attr('action');
            subwayScript.showSpinner();
            ajaxGetResults(action);
        });

        function ajaxGetResults(postUrl) {
            $.ajax({
                url: postUrl,
                type: 'POST',
                data: $form.serialize(),
                dataType: 'html',
                success: function (data) {
                    var mainContent = $(data).filter('#restaurant-main-content').html();
                    $('#restaurant-details-content').html(mainContent);

                    var footerContent = $(data).filter('#restaurant-footer-content').html();
                    $('#restaurant-details-footer').html(footerContent);
                    subwayScript.hideSpinner();

                    initRestaurantDetailsUIScript();

                    var storeNum = $('#storeNum').text();
                    orderViewModel.store.address1 = $('.restaurant-address').data('address1').trim();
                    orderViewModel.store.address3 = $('.restaurant-address').data('address3').trim();
                    orderViewModel.store.fullAddress = $('.restaurant-info').data('address') + ' ' + $('.restaurant-address').text().trim() + ' ' + $('.restaurant-address').data('city-state-zip');
                    orderViewModel.save();
                    subwayScript.bindPageTitle();

                    $('.btnOrderNow').click(function () {
                        analytics.locatorIndividualOrder(storeNum);

                        orderViewModel.store.address = $('.restaurant-info').data('address');
                        orderViewModel.store.id = subwayScript.checkSatelliteNumber($('.restaurant-info').data('storeid'));
                        orderViewModel.store.countryCode = $('.restaurant-info').data('countrycode').toLowerCase();
                        orderViewModel.store.maxProteinsForExpressOrder = $('.restaurant-info').data('maxProteinsForExpressOrder');
                        orderViewModel.save();

                        $.ajax({
                            url: $('#frmLanguageCode').attr('action'),
                            type: 'GET',
                            async: false,
                            data: { restaurantid: orderViewModel.store.id },
                            error: function () {
                                orderViewModel.store.languageCode = analytics.fallbackLanguage;
                                orderViewModel.save();
                            },
                            success: function (data) {
                                orderViewModel.store.languageCode = data.LanguageCode;
                                orderViewModel.save();

                                if (!orderViewModel.currentOrder.cartId) {
                                    $.ajax({
                                        url: $('#frmCreateCart').attr('action'),
                                        type: 'POST',
                                        cache: false,
                                        async: true,
                                        headers: { "cache-control": "no-cache" },
                                        data: {
                                            storeId: orderViewModel.store.id
                                        },
                                        error: function (jqXhr) {
                                            subwayScript.showAjaxError(jqXhr);
                                        },
                                        success: function (data) {
                                            orderViewModel.currentOrder.cartId = data.Cart.CartId;
                                            orderViewModel.currentOrder.cartQuantity = 0;
                                            orderViewModel.cartOpen = true;
                                            orderViewModel.save();
                                            subwayScript.setCookie('CartId', data.Cart.CartId, 90);
                                            SelectHeader();
                                        }
                                    });
                                }
                            }
                        });
                    });

                    $('#storePhone').click(function () { analytics.locatorCallStore(storeNum); });
                    $('#hrefDirections').click(function () { analytics.locatorGetDirections(storeNum); });

                    //Bold hours for current day
                    var dayOfWeek = new Date().getDay();
                    var $dayRow = $('tr[data-day="' + dayOfWeek + '"]');
                    $('tr', $dayRow).addClass('current-day');

                    //Possible values to display for open text
                    var openUntilText = $('#openDescription').data('openUntil');
                    var openText = $('#openDescription').data('open');

                    var now = moment();
                    var dateString = now.format('MM DD YYYY');
                    var todayHours = $('td[data-desc]', $dayRow).text();
                    $('#closingTime').text(todayHours);
                },
                error: function (jqXhr) {
                    subwayScript.showAjaxError(jqXhr);
                }
            });
        }
    };

    initRestaurantDetails();

    var initRestaurantDetailsUIScript = function () {
        var $carouselTab = $('#sync2 .hours');

        function mobileStyles() {
            var mobileText = $carouselTab.data('mobileText');
            $carouselTab.text(mobileText);
        }

        if ($(window).width() < 1024) {
            mobileStyles();
        }
        //global function to stick navigation to body element in mobile view
        function stickyNav() {
            $('.sticky2').stick_in_parent({ parent: '#stick-to', bottoming: false });
        }

        //Sticky script init  and mobile styles for when page resized
        if ($(window).width() < 1024) {
            $('.navbar').last().addClass('nav-shadow');
            stickyNav();
        } else {
            $('.navbar-sub').removeClass('sticky2');
        }

        var resizeTimer;
        $(window).resize(function (e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                if ($(window).width() < 1024) {
                    mobileStyles();

                    //resizes nav and subnav when the window is resized
                    //  $('.navbar-sub').addClass('sticky2');
                    $('.sticky2').trigger('sticky_kit:detach');
                    $('.sticky2').stick_in_parent({ parent: '#stick-to', bottoming: false });
                    $('.navbar').last().addClass('nav-shadow');
                } else {
                    var desktopText = $carouselTab.data('desktopText');
                    $carouselTab.text(desktopText);

                    //remove sticky nav functionality in desktop view
                    $('.sticky2').trigger('sticky_kit:detach');
                    $('.navbar').last().removeClass('nav-shadow');
                }
            }, 5);
        });

        // SYNCED CAROUSELS
        $(function () {
            // get page direction for carousel variable
            var direction = document.dir ? document.dir : document.getElementsByTagName('html')[0].getAttribute('dir');

            var sync1 = $('#sync1');
            var sync2 = $('#sync2');
            var itemCount = $('#sync2 .item').length;

            sync1.owlCarousel({
                singleItem: true,
                slideSpeed: 200,
                dragEndSpeed: 880,
                navigation: false,
                pagination: false,
                direction: direction,
                afterAction: syncPosition,

            });

            sync2.owlCarousel({
                items: itemCount,
                autoWidth: true,
                itemsDesktop: [1199, itemCount],
                itemsDesktopSmall: [979, itemCount],
                itemsTablet: [768, itemCount],
                itemsMobile: [479, itemCount],
                pagination: false,
                direction: direction,
                afterInit: function (el) {
                    el.find('.owl-item').eq(0).addClass('synced');
                }
            });

            function syncPosition(el) {
                var current = this.currentItem;
                $('#sync2')
                    .find('.owl-item')
                    .removeClass('synced')
                    .eq(current)
                    .addClass('synced');
                if ($('#sync2').data('owlCarousel') !== undefined) {
                    center(current);
                }
            }

            $('#sync2').on('click focus', '.owl-item', function (e) {
                e.preventDefault();
                var number = $(this).data('owlItem');
                sync1.trigger('owl.goTo', number);
            });

            function center(number) {
                var sync2visible = sync2.data('owlCarousel').owl.visibleItems;
                var num = number;
                var found = false;
                for (var i in sync2visible) {
                    if (num === sync2visible[i]) {
                        found = true;
                    }
                }

                if (found === false) {
                    if (num > sync2visible[sync2visible.length - 1]) {
                        sync2.trigger('owl.goTo', num - sync2visible.length + 2);
                    } else {
                        if (num - 1 === -1) {
                            num = 0;
                        }
                        sync2.trigger('owl.goTo', num);
                    }
                } else if (num === sync2visible[sync2visible.length - 1]) {
                    sync2.trigger('owl.goTo', sync2visible[1]);
                } else if (num === sync2visible[0]) {
                    sync2.trigger('owl.goTo', num - 1);
                }

            }

            var dayOfWeek = new Date().getDay();

            var $dayRow = $('tr[data-day="' + dayOfWeek + '"]');

            $('td', $dayRow).css('font-weight', 'bold').css('color', 'black');
            var time = $('td[data-desc]', $dayRow).text();
            var timeSections = time.split('-');
            if (timeSections.length === 2) {
                var closingTime = timeSections[1].trimLeft();
                $('#closingTime').text(closingTime);
            }

        }); //END SYNC CAROUSELS

    }

    function initMap() {
        var $map = $('#map');
        var lat = parseFloat($map.data('lat'));
        var long = parseFloat($map.data('long'));

        var restaurantLocation = { lat: lat, lng: long };
        var map = new google.maps.Map(document.getElementById('map'), {
            zoom: 15,
            center: restaurantLocation
        });

        var marker = new google.maps.Marker({
            position: restaurantLocation,
            map: map
        });
    }

}